module.exports = __webpack_public_path__ + "img/voucher5.2065a621.png";